import React from 'react';
import { LeftGroup, RightGroup } from 'Common/Components/CustomActionBar/styled';
import Pagination from 'Common/Components/Pagination';
import AddCredentialButton from './components/AddCredentialButton';
import ExportCSV from './components/ExportCSV';
import { Wrapper } from './styled';
import Actions from './components/Actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectCount } from 'store/Credentials/selectors';
import { setPageNumberCredentials } from 'store/Credentials/actions';
import { selectPage, selectRowsPerPage } from 'store/Filters/selectors';

const ActionBar = ({ withActions }) => {
  const dispatch = useDispatch();
  const total = useSelector(selectCount);
  const page = useSelector((state) => selectPage('credentials', state));
  const rowsPerPage = useSelector((state) => selectRowsPerPage('credentials', state));
  const onPrev = () => dispatch(setPageNumberCredentials(page - 1));
  const onNext = () => dispatch(setPageNumberCredentials(page + 1));

  return (
    <Wrapper>
        <LeftGroup>
            <AddCredentialButton />
            <ExportCSV isVulnDetail={ !withActions } />
            <Actions show={ withActions } />
        </LeftGroup>
        <RightGroup>
            <Pagination offset={ page } limit={ rowsPerPage } total={ total } onPrev={ onPrev } onNext={ onNext } />
        </RightGroup>
    </Wrapper>
  );
};

export default ActionBar;
